import { getArgFromUrl } from 'utils';
import { _T } from '@dana/components';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { langAtom } from 'store';

const Nav: React.FC<{
  close?: boolean;
  title: string;
  styleType?: 'white' | 'black';
  style?: React.CSSProperties;
  isT?: boolean;
  className?: string;
}> = ({ close = false, title, styleType = 'black', isT = false, className }) => {
  const [h, setH] = useState(0);
  // <div className='relative flex pt-3 justify-center h-[44px]'>
  //     <div className='absolute left-3 top-1/2 transform translate-y-[-25%] w-[24px] h-[24px] bg-cover' onClick={close} style={{ backgroundImage: `url(${require('asset/imgs/back.png')})` }}></div>
  //     <div className='pt-[2px] font-abeezee text-white font-bold text-[18px]' dir='auto'>{_T('公会')}</div>
  // </div>

  const navigate = useNavigate();
  const [lang, setLang] = useAtom(langAtom);

  useEffect(() => {
    const lan = getArgFromUrl('language');
    if (lan) {
      setLang(lan);
    }
    window.addEventListener('fromFlutter', function (event: any) {
      const { method, height } = event.detail;
      setH(Math.floor(height));
    });
    if ((window as any).toFlutter) {
      (window as any).toFlutter.postMessage(JSON.stringify({ method: 'getStatusBarHeight' }));
    }
  }, []);

  const goBack = () => {
    if (!close) {
      navigate(-1);
    } else {
      (window as any).toFlutter.postMessage(
        JSON.stringify({
          method: 'closeWebView',
        }),
      );
    }
  };

  const getImg = () => {
    return styleType === 'black' ? require('asset/imgs/back3.png') : require('asset/imgs/back.png');
  };

  return (
    <div
      className={`w-full ${className}`}
      style={
        {
          // marginTop: `-${h}px`
        }
      }
    >
      <div
        className="w-full"
        style={{
          height: `${h}px`,
          backgroundColor: styleType === 'black' ? '#fff' : 'transparent',
        }}
      ></div>
      <div
        className={`${styleType === 'black' ? 'bg-white' : 'transparent'} relative flex pt-3 justify-center h-[44px]`}
      >
        {lang === 'en' ? (
          <div
            className="absolute left-3 top-1/2 transform translate-y-[-40%] w-[24px] h-[24px] bg-cover"
            style={{ backgroundImage: `url(${getImg()})` }}
            onClick={goBack}
          ></div>
        ) : (
          <div
            className="rotate-180 absolute right-3 top-1/2 transform translate-y-[-40%] w-[24px] h-[24px] bg-cover"
            style={{ backgroundImage: `url(${getImg()})` }}
            onClick={goBack}
          ></div>
        )}
        <div
          className={`text-center font-sans font-bold text-[18px] ${styleType === 'black' ? 'text-[#333]' : 'text-[#fff]'}`}
          dir="auto"
        >
          {isT ? title : _T(title)}
        </div>
      </div>
    </div>
  );
};

export default Nav;
